import WorkspaceSiteSelector from "./WorkspaceSiteSelector";
import { ShareButton } from "@/components/share/ShareButton";
import { usePropertySafe } from "@/lib/contexts/PropertyContext";
import { useWorkspaceSafe } from "@/lib/contexts/WorkspaceContext";

export default function Header() {
  // Check if we're in a property or workspace context (not share mode)
  const propertyContext = usePropertySafe();
  const workspaceContext = useWorkspaceSafe();
  
  // Show share button if we have a property or workspace loaded
  const showShareButton = !!(propertyContext?.property || workspaceContext?.workspace);

  return (
    <div className="h-11 border-b border-border px-3 flex items-center justify-between shrink-0">
      <div className="flex items-center gap-2">
        <WorkspaceSiteSelector />
      </div>
      
      {/* Right side actions */}
      <div className="flex items-center gap-2">
        {showShareButton && <ShareButton />}
      </div>
    </div>
  )
}
